import { BrandThemeActions, persistedStore } from "@redux";
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getApolloClient } from "../../../../apollo";
import { CognitoUserSession } from "amazon-cognito-identity-js";

import {
  AccountActions,
  AuthActions,
  BookingActions,
  OffersActions,
  PaymentsActions,
  PreferredZonesThunks,
  FiltersActions
} from "@modules";
import { Auth } from "aws-amplify";

const logOutUser = () => {
  const dispatch = useDispatch();
  const silentSignOutZendesk = async (currentSession: CognitoUserSession) => {
    const idToken = currentSession.getIdToken().getJwtToken();
    const accessToken = currentSession.getAccessToken().getJwtToken();
    await fetch(
      `${window.config.API_GRAPHQL_ENDPOINT.replace(
        "graphql",
        "user/zendesk/logout"
      )}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ user_token: idToken }),
      }
    );
  };
  const handleLogout = async () => {
    try {
      // Force Amplify to log out through the Hosted UI process
      localStorage.setItem("amplify-signin-with-hostedUI", "true");
      localStorage.setItem("amplify-redirected-from-hosted-ui", "true");
      const currentSession = await Auth.currentSession();
      silentSignOutZendesk(currentSession).catch((error) => {
        console.error("Error during Zendesk logout:", error);
      });
      await Auth.signOut({ global: true });
    } catch (e) {
      dispatch(AuthActions.logOutUser());
      await getApolloClient().cache.reset();
      dispatch(AccountActions.setUserBalance(null));
      dispatch(BookingActions.initBookingOrders());
      dispatch(OffersActions.initOrderItems());
      dispatch(BrandThemeActions.resetBrandTheme());
      dispatch(PaymentsActions.resetPayment());
      dispatch(PreferredZonesThunks.resetPreferredZonesStore());
      dispatch(FiltersActions.resetState());
      window.localStorage.removeItem('persist:root');
      window.localStorage.clear();
      persistedStore.purge();
    }

  }

  useEffect(() => {
    handleLogout()
  }, []);

  return  <View style={styles.container}>
      <ActivityIndicator size="large" />
      <Text style={styles.text}>Logging you out...</Text>
    </View>
}


const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF'
  },
  text: {
    marginTop: 12,
    fontSize: 16,
    color: '#333333'
  }
});

export default logOutUser;